import type { TaskPullRequestAutomation } from "../persistence/records"

export type PullRequestAutomationView = Pick<TaskPullRequestAutomation, "phase"> & {
    delivery?: Pick<NonNullable<TaskPullRequestAutomation["delivery"]>, "operation">
    hold?: Pick<NonNullable<TaskPullRequestAutomation["hold"]>, "reason">
}

const HOLD_STATUS: Record<string, string> = {
    conflicts: "Conflicts · needs attention",
    behind: "Branch behind · needs attention",
    changes_requested: "Changes requested",
    checks_failed: "Checks failing",
    feedback: "New review feedback",
    ready: "Ready to land",
    closed: "PR closed",
    monitoring_failed: "PR monitoring needs attention",
    watch_changed: "Watch PR changed · needs attention",
    delivery_blocked: "PR repair blocked",
    dispatch_failed: "PR repair could not start",
    delivery_failed: "PR repair failed",
    delivery_cancelled: "PR repair cancelled",
    unchanged: "Fix did not change the PR",
    landing_incomplete: "Previous landing needs attention",
    closeout_incomplete: "Previous closeout needs attention",
}

export function pullRequestAutomationStatus(automation: PullRequestAutomationView): string {
    if (automation.phase === "running") return automation.delivery?.operation === "repair" ? "Fixing PR" : "Previous PR work finishing"
    if (automation.phase === "queued") return "PR fix queued"
    if (automation.phase === "attention") return HOLD_STATUS[automation.hold?.reason ?? ""] ?? "PR needs attention"
    return "Watching PR"
}
